import React, { Component } from 'react'

import Header from './Header'
import Body from './Body'
import TransferHistory from './TransferHistory'

class BalanceScreen extends Component {
  render() {
    return (
      <div>
        <Header />
        <Body />
        <TransferHistory />
      </div>
    )
  }
}
export default BalanceScreen



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/InternetBankingSimulatorApp/screens/BalanceScreen/index.js